function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M72.18 42.193v36.011H27.82V42.193H13.08v50.746h73.839V42.193H72.18zM86.919 34.819V7.061H72.18v27.758h14.739zM57.611 34.819V7.061H42.869v27.758h14.742zM27.82 34.819V7.061H13.08v27.758h14.74z"
}));

var SvgLogoTransparentNoText = function SvgLogoTransparentNoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 73.83899688720703 85.87799835205078",
    style: {
      width: "100%",
      height: "100%",
      zIndex: 5
    }
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(0 0) scale(1)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 73.83899688720703,
    height: 85.87799835205078,
    viewBox: "13.079999923706055 7.060999870300293 73.83899688720703 85.87799835205078"
  }, props), _ref))));
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDczLjgzODk5Njg4NzIwNzAzIDg1Ljg3Nzk5ODM1MjA1MDc4IiBzdHlsZT0id2lkdGg6IDEwMCU7IGhlaWdodDogMTAwJTsgei1pbmRleDogNTsiPjxnPjxnIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIHNjYWxlKDEpIj48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iNzMuODM4OTk2ODg3MjA3MDMiIGhlaWdodD0iODUuODc3OTk4MzUyMDUwNzgiIHZpZXdCb3g9IjEzLjA3OTk5OTkyMzcwNjA1NSA3LjA2MDk5OTg3MDMwMDI5MyA3My44Mzg5OTY4ODcyMDcwMyA4NS44Nzc5OTgzNTIwNTA3OCI+PGcgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik03Mi4xOCA0Mi4xOTN2MzYuMDExSDI3LjgyVjQyLjE5M0gxMy4wOHY1MC43NDZoNzMuODM5VjQyLjE5M0g3Mi4xOHpNODYuOTE5IDM0LjgxOVY3LjA2MUg3Mi4xOHYyNy43NThoMTQuNzM5ek01Ny42MTEgMzQuODE5VjcuMDYxSDQyLjg2OXYyNy43NThoMTQuNzQyek0yNy44MiAzNC44MTlWNy4wNjFIMTMuMDh2MjcuNzU4aDE0Ljc0eiIvPjwvZz48L3N2Zz48L2c+PC9nPjwvc3ZnPg==";
export { SvgLogoTransparentNoText as ReactComponent };